import { YOO_FINDS_CDN } from "@/common";

export const YOO_FINDS_OG_IMAGE = `${YOO_FINDS_CDN}/pc/open-graph/yoo-finds-og-image.webp`;
